import { connect } from "react-redux";
import { updateForgotPasswordRequest } from "../../actions/LoginActions"
import { addFlashMessage } from "../../actions/FlashMessagesAction"
import ResetPassword from "../../components/account/ResetPassword"

export default connect(null, { updateForgotPasswordRequest, addFlashMessage })(ResetPassword)